import React, { useContext } from 'react';
import { useApolloClient } from '@apollo/client';
import { useRouteMatch } from 'react-router';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import LogoButton from '../NavigationDrawer/LogoButton';
import { TabNodeContext } from '../../../providers/TabNodeProvider';
import { ModuleProps } from 'types';
import useStore from 'store';

const useStyles = makeStyles((theme: Theme) => {
  const APP_BAR_HEIGHT = 70;
  const APP_MOBILE_BAR_HEIGHT = 72;

  return {
    root: {
      flexGrow: 1
    },
    appBar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: APP_BAR_HEIGHT,
      background: 'white',
      color: 'black',
      borderBottom: `1px solid ${theme.palette.divider}`,
      [theme.breakpoints.up('sm')]: {
        height: APP_MOBILE_BAR_HEIGHT
      }
    },
    appBarGutters: {
      paddingRight: theme.spacing(5),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(5)
      }
    },
    title: {
      fontWeight: 600,
      lineHeight: theme.typography.pxToRem(40)
    },
    moreOptionsIcon: {
      color: 'black'
    },
    addButton: {
      background: theme.palette.primary.main,
      marginRight: theme.spacing(2)
    },
    searchContainer: {
      margin: 0,
      [theme.breakpoints.up('sm')]: {
        marginRight: theme.spacing(4)
      }
    },
    actionsHolder: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  };
});

const AppHeaderBar: React.FC<ModuleProps> = ({ getTitle, children, ...moduleProps }) => {
  const styles = useStyles();
  const client = useApolloClient();
  const match = useRouteMatch();
  const { setNode } = useContext(TabNodeContext);
  const [{ ui }, { setNavigationDrawer }] = useStore();
  const setNodeRef = (element: HTMLDivElement): void => {
    setNode(element);
  };

  const appBarTitle = getTitle({ match, client, ...moduleProps } as any);

  const toggleDrawer = (): void => setNavigationDrawer(!ui.navigationDrawerOpen);

  return (
    <div className={styles.root}>
      <AppBar elevation={0} position="static">
        <Toolbar
          classes={{
            root: styles.appBar,
            gutters: styles.appBarGutters
          }}
        >
          {!ui.isDesktop && <LogoButton onClick={toggleDrawer} />}
          <Typography
            noWrap={true}
            variant="h1"
            component="h1"
            className={styles.title}
            ref={setNodeRef}
            tabIndex={0}
          >
            {appBarTitle}
          </Typography>
          <div className={styles.actionsHolder}>{children}</div>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default AppHeaderBar;
